var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cemetery-sector-statistic" }, [
    _c("div", { staticClass: "total" }, [
      _c("div", { staticClass: "info" }, [
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t(`${_vm.modelTranslateID}.total_sectors`))),
        ]),
        _vm._v(" "),
        _c("h2", { staticClass: "amount" }, [_vm._v(_vm._s(_vm.total))]),
      ]),
      _vm._v(" "),
      _vm.allowShowSectors && _vm.total > 0
        ? _c(
            "a",
            {
              staticClass: "btn btn-link",
              attrs: { "aria-disabled": "false" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onShowCemeterySectors.apply(null, arguments)
                },
              },
            },
            [
              _c("span", {}, [
                _vm._v(_vm._s(_vm.$t(`${_vm.actionsTranslateID}.see_sectors`))),
              ]),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "detailed-statistics" },
      _vm._l(_vm.statistics, function (item, idx) {
        return _c(
          "div",
          {
            key: `cemetery-statistics-item-${idx}`,
            staticClass: "statistics-item",
          },
          [
            _c("div", {
              staticClass: "mark",
              style: { backgroundColor: item.color },
            }),
            _vm._v(" "),
            _c("div", [
              _c("p", { staticClass: "title" }, [_vm._v(_vm._s(item.name))]),
              _vm._v(" "),
              _c("h4", { staticClass: "amount" }, [
                _vm._v(_vm._s(item.amount)),
              ]),
            ]),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "total" }, [
      _c("div", { staticClass: "info" }, [
        _c("p", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t(`${_vm.modelTranslateID}.total_interments`))),
        ]),
        _vm._v(" "),
        _c("h2", { staticClass: "amount" }, [
          _vm._v(_vm._s(_vm.total_interments)),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }